import styled, { css } from 'styled-components';

export const BpWrapper = styled.div<{
	inline?: boolean;
}>`
	width: 100%;

	${({ inline }) =>
		inline &&
		css`
			width: auto;
			display: inline-block;
		`}
`;

export const Wrapper = styled.div<{
	margin?: string;
	debug?: boolean;
	shouldOverrideBpc: boolean;
	size: string | number;
	customCss?: string;
}>`
	overflow: visible;
	position: relative;

	${({ margin }) =>
		margin &&
		css`
			margin: ${margin};
		`}

	${({ debug, shouldOverrideBpc, size }) =>
		debug &&
		css`
			${shouldOverrideBpc &&
				size &&
				css`
					border: 1px dashed black;

					&::before {
						content: 'controlled: ${size}';
						position: absolute;
						top: 0;
						left: 0;
						background-color: white;
						color: black;
						display: flex;
						align-items: center;
						justify-content: center;
						z-index: 9999;
						border: 1px dashed red;
						font-size: 10px;
						min-height: 15px;
						z-index: 9999;
						padding: 0 3px;
						font-family: monospace;
					}
				`}
		`}

		${({ customCss }) =>
			customCss &&
			css`
				${customCss}
			`}
`;

export const Container = styled.div<{
	yGap?: number;
	xGap?: number;
	align?: string;
	reverse?: boolean;
	isStacked: boolean;
	direction?: string;
	isColumn?: boolean;
}>`
	display: flex;
	flex-wrap: wrap;

	${({ yGap, xGap }) => css`
		margin: 0 -${xGap}px -${yGap}px 0;
	`}

	${({ align }) => css`
		justify-content: ${align === 'left'
			? 'flex-start'
			: align === 'right'
			? 'flex-end'
			: align === 'center'
			? 'center'
			: align === 'between'
			? 'space-between'
			: 'initial'};
	`}

	${({ isColumn }) =>
		isColumn &&
		css`
			flex-direction: ${isColumn ? 'column' : 'row'};
		`}

	${({ reverse, isStacked }) =>
		reverse &&
		css`
			flex-direction: ${isStacked ? 'column-reverse' : 'row-reverse'};
		`}
`;

export const Segment = styled.div<{
	debug: boolean;
	isStacked: boolean;
	width?: string;
	yGap: number;
	xGap: number;
	leftPadding?: number;
	rightPadding?: number;
}>`
	border: 0 solid transparent;
	background-clip: padding-box;
	box-sizing: border-box;

	${({ debug }) =>
		debug &&
		css`
			/* Note we can't use border here due to Segment relying
			on the transparent border to achieve the grid gap. */
			box-shadow: inset 0 0 0 2px black;
		`}

	${({ isStacked, width, yGap, xGap }) => css`
		width: ${isStacked ? '100%' : width};
		border-width: 0 ${xGap}px ${yGap}px 0;
	`}

	${({ leftPadding, rightPadding }) => css`
		padding-left: ${leftPadding ?? '0'}px;
		padding-right: ${rightPadding ?? '0'}px;
	`}
`;
